// extracted by mini-css-extract-plugin
export default {"containerBtn":"styles-scoped__containerBtn--Gj3EA","btn":"styles-scoped__btn--UAvHm","formContainer":"styles-scoped__formContainer--t2aj2","icon":"styles-scoped__icon--fHzNj"};